import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@lenovo/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BaseHardwareScanModalComponent } from '../base-hardware-scan-modal';

@Component({
	selector: 'vtr-modal-hardware-scan-customize',
	templateUrl: './modal-hardware-scan-customize.component.html',
	styleUrls: ['./modal-hardware-scan-customize.component.scss'],
})
export class ModalHardwareScanCustomizeComponent
	extends BaseHardwareScanModalComponent
	implements OnInit
{
	@Input() items: any[];
	public disableButtonRun = true;

	constructor(
		private dialogRef: MatDialogRef<ModalHardwareScanCustomizeComponent>,
		private translate: TranslateService
	) {
		super();
	}

	public ngOnInit() {
		this.disableButtonRun = !this.isAtLeastOneSelected();
	}

	// Used to signalize to the caller that the modal is being closed.
	public closeModal() {
		this.dialogRef.close('close');
	}

	public onClickRun() {
		if (this.isAtLeastOneSelected()) {
			this.dialogRef.close(this.items);
		}
	}

	public receiveSelect() {
		this.disableButtonRun = !this.isAtLeastOneSelected();
	}

	private isAtLeastOneSelected() {
		return this.items.some((x) => x.selected || x.indeterminate);
	}
}
